<template>
	<div>
		<VueHtml2pdf
			:show-layout="false"
			:float-layout="true"
			:enable-download="false"
			:preview-modal="true"
			:paginate-elements-by-height="1400"
			:filename="filename"
			:pdf-quality="2"
			:manual-pagination="false"
			pdf-format="a4"
			pdf-orientation="portrait"
			pdf-content-width="800px"
			ref="html2Pdf"
			:html-to-pdf-options="options"
		>

		<!-- 
			:html-to-pdf-options="options"
			pdf-content-width="800px"
			:paginate-elements-by-height="1400" -->

			<template slot="pdf-content">
				<v-app>
					<v-main class="mx-8">
						<!-- <div style="margin: 12px 12px"></div> -->
    					<!-- <v-container > -->

						<div class="mx-8">
							<h3 class="text-center">Інформація про страхового посередника</h3>
							<br>
							<!-- <p class="text-center">
								<h3>Інформація про страхового посередника</h3>
							</p> -->
							<v-simple-table dense >
								<template v-slot:default>
									<tbody>
										<tr>
											<td class="align-top-cell">1) Страховий агент</td>
											<td>
												<div v-if="mainData.imCat=='P'">{{ mainData.pib }}</div>
												<div v-else>{{ mainData.ianFullName }} ({{ mainData.ianShortName }})</div>
												<div v-if="mainData.imNumIdent">Ідентифікаційний код: {{ mainData.imNumIdent }}</div>
												<div v-if="addres.iaFull">Адреса: {{ addres.iaFull }}</div>
												<!-- <div>Банківська ліцензія НБУ №148 від 05.10.2011 року</div> -->
												<div v-if="addres.iaWebsite">{{ addres.iaWebsite }}</div>
											</td>
										</tr>
										<tr>
											<td class="align-top-cell">2) Повноваження Страхового агента</td>
											<td>
												<div>{{ mainData.ianShortName }} є страховим агентом, який діє від імені та за дорученням страхової компанії та надає посередницькі послуги з укладення договорів страхування, в тому числі:</div>
												<div>1. рекламування та/або проведення маркетингових, рекламних та інших підготовчих заходів, спрямованих на укладення договорів страхування, зокрема, але не виключно, надання інформації про умови договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами, проведення порівняльного аналізу за критеріями клієнтів, консультування щодо умов договору страхування відповідно до критеріїв та/або потреб, визначених клієнтами;</div>
												<div>2. пропонування, пропозиція та консультування клієнта щодо укладення договору страхування, проведення іншої роботи з підготовки до укладення договорів страхування;</div>
												<div>3. укладення та внесення змін до договору страхування, зокрема, але не виключно, залучення до оцінювання страхового ризику, вірогідності настання страхової події, оформлення документів та розрахунків щодо сплати страхової премії.</div>
											</td>
										</tr>
										<tr>
											<td class="align-top-cell">3) Номер запису в Реєстрі посередників.</td>
											<td>
												<div>{{ mainData.icrRegNum }}</div>
												<div>Інформація про посередника в Державному реєстрі фінансових установ зазначено на вебсторінці</div>
												<div>Реєстру за посиланням.</div>
											</td>
										</tr>
										<tr>
											<td class="align-top-cell">4) Можливість надання індивідуальної консультації та рекомендацій щодо умов страхового продукту.</td>
											<td>{{ mainData.ianShortName }} надає індивідуальні консультації щодо умов страхового продукту та рекомендації щодо вибору страхового продукта відповідно до потреб клієнта при зверненні клієнта у відділення Банку або у контактний центр банку ({{ addres.iaPhone }}).</td>
										</tr>
										<tr>
											<td class="align-top-cell">Перелік відокремлених підрозділів страхового посередника, в яких споживач може укласти договір страхування</td>
											<td>Будь-яке відділення {{ mainData.ianShortName }}, яке здійснює діяльність на територіях, на яких органи державної влади України здійснюють свої повноваження. З переліком діючих відділень банку та місцем розташування можна ознайомитися за посиланням {{ addres.iaWebsite }}/map</td>
										</tr>
										<tr>
											<td class="align-top-cell">Способи сплати страхової премії за договорами страхування</td>
											<td>Страхова премія, за укладеними за сприяння {{ mainData.ianShortName }} договорами страхування сплачується страхувальниками безпосередньо на рахунок страхової компанії, з яким укладено договір страхування та який зазначено в договорі страхування.</td>
										</tr>
										<tr>
											<td class="align-top-cell">Способи здійснення страховим посередником страхових виплат</td>
											<td>Страхова виплата за укладеними за сприяння {{ mainData.ianShortName }} договорами страхування в разі настання страхової події здійснюється страховою компанією, з яким укладено договір страхування в порядку, строки та спосіб, які зазначені в договорі страхування. Зарахування та перерахування страхових виплат з поточного рахунку страхового посередника договорами страхування не передбачено.</td>
										</tr>
										<tr>
											<td class="align-top-cell">Перелік та порядок надання асистуючих послуг страховим посередником</td>
											<td>{{ mainData.ianShortName }} не надає асистуючі послуги.</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>

							<br>
							<h5>5) Страхові компанії, продукти яких реалізує Страховий агент:</h5>
							<br>
							<v-simple-table dense >
								<template v-slot:default>
									<tbody>
										<tr v-for="(item, index) in insurAgentInSkInfo" :key="index">
											<td>{{ index+1 }}</td>
											<td>
												<div>{{ item.skShortName }}</div>
												<div>код ЄДРПОУ {{ item.skNumident }}</div>
												<!-- <div>04070, Київ вул. Іллінська,8</div> -->
												<!-- <div>(044)3911122</div> -->
												<!-- <div>https://arx.com.ua/</div> -->
												<!-- <div>Назви класів страхування можна переглянути в кінці документу.</div> -->
											</td>
											<td>
												<!-- <div>Перелік послуг, що надається страховиком зазначено на вебсайті страховика https://arx.com.ua/</div>
												<div>Інформація про страховика з Державного реєстру фінансових установ зазначено на вебсторінці Реєстру за посиланням.</div>
												<div>Перелік класів за якими Страховий агент реалізує страхові продукти: 1, 3, 8, 9, 10, 13</div> -->


												<div v-for="(product, pindex) in insurProducts.some((element) => element.ipInsurNumident === item.skNumident )" :key="pindex">
													{{ product.ipName }}
												</div>
												

												<!-- <div>{{ mainData.ianFullName }} ({{ mainData.ianShortName }})</div>
												<div>Ідентифікаційний код: {{ mainData.imNumIdent }}</div>
												<div>Адреса: {{ addres.iaFull }}</div>
												<div>Банківська ліцензія НБУ №148 від 05.10.2011 року</div>
												<div>{{ addres.iaWebsite }}</div> -->
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>

							<br>

							<v-simple-table dense >
								<template v-slot:default>
									<tbody>
										<tr>
											<td class="align-top-cell">6) Наявність істотної участі в будь-якому страховику.</td>
											<td>{{ mainData.ianShortName }} не має істотної участі в будь-якому із страховиків.</td>
										</tr>
										<tr>
											<td class="align-top-cell">7) Наявність істотної участі страховика у страховому агенті.</td>
											<td>Будь-який страховик не має істотної участі в {{ mainData.ianShortName }}</td>
										</tr>
										<tr>
											<td class="align-top-cell">8) Вид винагороди за укладення договору страхування, порядок та умови її виплати.</td>
											<td>За укладання договорів страхування страховий агент отримує комісійну винагороду у розмірі фіксованого відсотка від страхової премії/страхової суми за договором страхування. (винагорода входить до складу страхової премії/страхової суми). Винагороду страховому агенту сплачує страхова компанія.</td>
										</tr>
										<tr>
											<td class="align-top-cell">9) Розмір та спосіб оплати послуг страхового агента безпосередньо клієнтом.</td>
											<td>Клієнт не оплачує послуги страхового агента.</td>
										</tr>
										<tr>
											<td class="align-top-cell">10) Будь-які інші платежі (крім страхової премії), які клієнт зобов’язаний сплатити відповідно до умов договору страхування після його укладення.</td>
											<td>Будь-які інші платежі (крім страхової премії) Клієнт не повинен сплачувати відповідно до умов договору страхування після його укладення.</td>
										</tr>
										<tr>
											<td class="align-top-cell">Порядок обробки персональних даних споживачів та дії страхового посередника щодо їх захисту</td>
											<td>Персональні дані обробляються виключно з метою та в межах вимог законодавчих та інших нормативно-правових актів України у сфері захисту персональних даних, в тому числі щодо їх збирання, обробки, зберігання. Страхувальник укладаючи договір страхування надає згоду на обробку персональних даних в обсязі, необхідному для укладання та виконання договору страхування. З Інформацією про порядок обробки, захисту персональних даних клієнтів в {{ mainData.ianShortName }} можна ознайомитись на вебсайті банку за посиланням: {{ addres.iaWebsite }}/pro-porjadok-i-proceduruzahystu-personalnyh-danyh</td>
										</tr>
										<tr>
											<td class="align-top-cell">11) Інформація про механізми та способи захисту прав споживачів фінансових послуг.</td>
											<td>Звернення розглядаються і вирішуються Страховиком у термін не більше одного місяця від дня їх надходження, а ті, які не потребують додаткового вивчення, - не пізніше п'ятнадцяти днів від дня їх отримання. Якщо в місячний термін вирішити порушені у зверненні питання неможливо, уповноважена особа Страховика встановлює необхідний термін для його розгляду, що не може перевищувати сорока п'яти днів. Звернення може бути усним за допомогою засобів телефонного зв’язку через контактний центр Страховика та/або страхового агента чи письмовим на електронну пошту Страховика або засобами поштового зв’язку на його адресу. Подання клієнтом скарги до Страховика або компетентного органу не позбавляє споживача права звернутися до суду відповідно до чинного законодавства, а у разі незгоди споживача з прийнятим за скаргою рішенням - безпосередньо до суду.</td>
										</tr>
										<tr>
											<td class="align-top-cell">Контакти, за якими споживач відповідно до законодавства України має право звернутися до страховог опосередника, Національного банку України та інших уповноважених державних органів.</td>
											<td><strong>Контактні дані страхової компанії</strong> з якою споживач уклав договір страхування зазначені в пункті 5 цього документу, в договорі страхування та на вебсайті страхової компанії.
												<div>Контактні дані {{ mainData.ianShortName }}:</div>
												<div>Канали зв’язку:</div>
												<div>Адреса для листування:</div>
												<div>Електронна пошта:</div>
												<div>Канали надання відповіді клієнту на звернення:</div>
												<div>- електронні ( e-mail);</div>
												<div>- Укрпошта;</div>
												<div>- телефонний зв'язок;</div>
												<div>- особистий прийом клієнтів.</div>
												<div>Контактні дані НАЦІОНАЛЬНОГО БАНКУ УКРАЇНИ</div>
												<div>Скарга на дії чи рішення фінансової установи найзручніше подати до Національного банку через дистанційні канали:</div>
												<div>■ надішліть звернення онлайн або на електронну пошту nbu@bank.gov.ua, використовуючи спеціальну форму;</div>
												<div>■ надішліть лист разом із документами на адресу: 01601, м. Київ, вул. Інститутська, 9.</div>
												<div>■ звернення до контакт-центру за телефоном 0 800 505 240.</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>

							<div class="html2pdf__page-break"/>

							<section class="pdf-item">
								<p><strong>Назви класів страхування:</strong></p>
								<p>Клас 1 - страхування від нещасного випадку (у тому числі на випадок виробничої травми та професійного захворювання);</p>
								<p>Клас 2 - страхування на випадок хвороби (у тому числі медичне страхування);</p>
								<p>Клас 3 - страхування наземних транспортних засобів (крім залізничного рухомого складу);</p>
								<p>Клас 4 - страхування залізничного рухомого складу;</p>
								<p>Клас 5 - Страхування повітряних суден;</p>
								<p>Клас 7 - Страхування майна, що перевозиться (включаючи вантаж, багаж (вантажобагаж);</p>
								<p>Клас 8 - страхування майна від вогню та небезпечного впливу природних явищ;</p>
								<p>Клас 9 - страхування майна від шкоди, заподіяної градом, морозом, іншими подіями (включаючи крадіжку, розбій, грабіж, умисне пошкодження/знищення майна), крім подій, визначених у класі 8;</p>
								<p>Клас 10 - страхування відповідальності, яка виникає внаслідок використання наземного транспортного засобу (у тому числі відповідальності перевізника);</p>
								<p>Клас 13 - страхування іншої відповідальності (крім визначеної у класах 10, 11, 12);</p>
								<p>Клас 16 - страхування інших фінансових ризиків (крім визначених класами 14, 15);</p>
								<p>Клас 18 - страхування витрат, пов’язаних з наданням допомоги (асистанс) особам, які потрапили у скрутне становище під час здійснення подорожі;</p>
								<p>Клас 19 – страхування життя (крім визначеної у класах 20, 21, 22, 23)</p>
							</section>
						</div>

						<!-- <div class="mx-8">
							<v-avatar size="48px">
								<img :src="logo">
							</v-avatar>
							<span class="ml-4 text-h4">{{ logoTitle }}</span>

							<h2 class="text-center">{{ title }}</h2>

							<v-row no-gutters>
								<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6">
									№ {{ id }}
								</v-col>
								<v-col cols="12" xs="6" sm="6" md="6" lg="6" xl="6" class="text-right">
									{{ date | formatDateTime }}
								</v-col>
								<v-col cols="12" class="text-right">
									{{ username }}
								</v-col>
							</v-row>
							<br>
							<hr>
							<br>
						</div>

						<div class="mx-8" v-if="generals.length">
							<v-simple-table dense >
								<template v-slot:default>
									<tbody>
										<tr v-for="(item, index) in generals" :key="index">
											<td>{{ item.name }}</td>
											<td>{{ item.value }}</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</div>

						<div class="my-8 mx-8" v-if="estimates.length">
							<h3>Транспортні засоби</h3><br>
							<v-simple-table dense>
								<template v-slot:default>
									<thead>
										<tr>
											<th class="text-left">Назва</th>
											<th class="text-left">Оцінка</th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="estimate in estimates" :key="estimate.id">
											<td  width="80%">
												<p v-if="estimate.hasOwnProperty('request')">
													<span v-if="estimate.request.hasOwnProperty('id')"><b>Id: </b><span>{{ estimate.request.id }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('number') && estimate.request.number" class="ml-2"><b>Номер: </b><span>{{ estimate.request.number }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('vin') && estimate.request.vin" class="ml-2"><b>Vin: </b><span>{{ estimate.request.vin }}</span></span>
													<span v-if="(estimate.request.hasOwnProperty('brand') && estimate.request.brand) || (estimate.request.hasOwnProperty('model') && estimate.request.model)" class="ml-2">
														<b>Марка і модель: </b>
														<span v-if="estimate.request.hasOwnProperty('brand') && estimate.request.brand">
															<span v-if="estimate.request.brand.hasOwnProperty('name')">{{ estimate.request.brand.name }}</span>
														</span>
														<span v-if="estimate.request.hasOwnProperty('model') && estimate.request.model">
															<span v-if="estimate.request.model.hasOwnProperty('name')" class="ml-2">{{ estimate.request.model.name }}</span>
														</span>
													</span>
													<span v-if="estimate.request.hasOwnProperty('yearProd') && estimate.request.yearProd" class="ml-2"><b>Рік виробництва: </b><span>{{ estimate.request.yearProd }}</span></span>
													<span v-if="estimate.request.hasOwnProperty('engineVolume') && estimate.request.engineVolume" class="ml-2"><b>Об'єм двигуна: </b><span>{{ estimate.request.engineVolume }}</span></span>
												</p>
											</td>
											<td  width="20%" class="text-right">
												<div v-if="estimate.hasOwnProperty('avgPriceUAH')">{{ estimate.avgPriceUAH | toCurrencyUAH }}</div>
												<div v-if="estimate.hasOwnProperty('avgPriceUSD')">{{ estimate.avgPriceUSD | toCurrencyUSD }}</div>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</div> -->
					</v-main>	
				</v-app>
			</template>
		</VueHtml2pdf>
	</div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
/*
https://www.npmjs.com/package/vue-html2pdf
*/
export default {
	components: { VueHtml2pdf },
	data () {
		return {
			title: 'Оцінка парку транспортних засобів',
			logo: require('../../assets/logo.svg'),
			logoTitle: 'Ortica Systems',
			
			options: {
				//margin: [10,10,10,10],
				margin: [10,0,10,0],
				//filename: `Інформація про страхового посередника.pdf`,
				image: { type: 'jpeg', quality: 0.98 },
				enableLinks: false,
				html2canvas: { scale: 1, useCORS: true },
				jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
				pagebreak: { avoid: ['tr'], mode: "css", before: "#nextpage1" },

				//pagebreak: { avoid: "tr", mode: "css", before: "#nextpage1", after: "1cm" },
			}
		}
	},
	props: {
		item: 		{ type: Object, default: () => {} },
	},

	computed: {
		mainData() {
			return this.item?.mainData ? this.item.mainData : {}
		},
		addres() {
			return this.item?.addres ? this.item.addres : {}
		},
		insurAgentInSkInfo() {
			return this.item?.insurAgentInSkInfo ? this.item.insurAgentInSkInfo : []
		},
		insurProducts() {
			return this.item?.insurProducts ? this.item.insurProducts : []
		},

		filename() {
			return `Інформація про страхового посередника.pdf`
		},

		/* id() {
			return this.item?.id ? this.item.id: null;
		},

		date() {
			return this.item?.date ? this.item.date : null;
		},

		username() {
			return this.item?.user?.name ? this.item.user.name: '';
		},

		filename() {
			return this.title + ' ' + this.id
		},

		generals() {
			let result = [];

			if(this.item?.code) result.push({ name: 'Код', value: this.item.code})
			if(this.item?.name) result.push({ name: 'Назва', value: this.item.name})
			if(this.item?.description) result.push({ name: 'Опис', value: this.item.description})
			if(this.item?.type?.name) result.push({ name: 'Тип', value: this.item.type.name})
			//if(this.item?.minPriceUAH > 0) result.push({ name: 'Мінімальна ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.minPriceUAH)})
			//if(this.item?.minPriceUSD > 0) result.push({ name: 'Мінімальна ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.minPriceUSD)})
			if(this.item?.avgPriceUAH > 0) result.push({ name: 'Середня ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.avgPriceUAH)})
			if(this.item?.avgPriceUSD > 0) result.push({ name: 'Середня ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.avgPriceUSD)})
			//if(this.item?.maxPriceUAH > 0) result.push({ name: 'Максимальна ціна, UAH', value: this.$options.filters.toCurrencyUAH(this.item.maxPriceUAH)})
			//if(this.item?.maxPriceUSD > 0) result.push({ name: 'Максимальна ціна, USD', value: this.$options.filters.toCurrencyUSD(this.item.maxPriceUSD)})
			if(this.item?.estimates) result.push({ name: 'Кількість оцінок', value: this.item.estimates.length})

			return result
		},

		estimates() {
			return this.item?.estimates ? this.item.estimates: [];
		}, */
	},

	methods: { 
		/* adverts(items) {
			const sorted = [...items].sort((a, b) => parseInt(a.price) - parseInt(b.price));
			return sorted
		}, */

        generate () {
			//console.log('\\pdf\\VehicleEstimate.vue', 'generate', 'item', this.item)
			this.$refs.html2Pdf.generatePdf()            
        },
    },

}
</script>

<style>
    table.print-friendly tr td, table.print-friendly tr th {
        page-break-inside: avoid;
    }

	.align-top-cell {
		vertical-align: top;
	}
</style>